import React from 'react';
import { Icon } from '@chakra-ui/react';

export const CelebrationIcon = (props) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" id="celebration_black_24dp" viewBox="0 0 60 60" {...props}>
      <g id="Group_87478" data-name="Group 87478">
        <path id="Rectangle_147743" fill="none" d="M0 0h60v60H0z" data-name="Rectangle 147743" />
      </g>
      <g id="Group_87481" data-name="Group 87481" transform="translate(5 2.5)">
        <g id="Group_87480" data-name="Group 87480">
          <g id="Group_87479" data-name="Group 87479">
            <path
              id="Path_395139"
              d="m2 43 35-12.5L14.5 8zm25-15L9.5 35.5 17 18z"
              fill="currentColor"
              data-name="Path 395139"
              transform="translate(-2 9.5)"
            />
            <path
              id="Path_395140"
              d="m18 24.7 12.5-15a3.9 3.9 0 0 1 5 0v2.5l5-5H38a7.2 7.2 0 0 0-10 0L13 19.7z"
              fill="currentColor"
              data-name="Path 395140"
              transform="translate(14.5 5.3)"
            />
            <path
              id="Path_395141"
              d="M11.5 13H9l5 5v-2.5a7.2 7.2 0 0 0 0-10V3L9 8h2.5a4 4 0 0 1 0 5z"
              fill="currentColor"
              data-name="Path 395141"
              transform="translate(8.5 2)"
            />
            <path
              id="Path_395142"
              d="m20 13.2-5 2.5 5 5 2.5-5a3.9 3.9 0 0 1 5 0l5 5 2.5-5-5-2.5a7.2 7.2 0 0 0-10 0z"
              fill="currentColor"
              data-name="Path 395142"
              transform="translate(17.5 14.3)"
            />
            <path
              id="Path_395143"
              d="M21 13.5 11 21l5 5 7.5-10a7.2 7.2 0 0 0 0-10L21 1l-5 5 5 2.5a4 4 0 0 1 0 5z"
              fill="currentColor"
              data-name="Path 395143"
              transform="translate(11.5 -1)"
            />
          </g>
        </g>
      </g>
    </Icon>
  );
};
